import { render, staticRenderFns } from "./star-rating.vue?vue&type=template&id=71f68a59&"
import script from "./star-rating.vue?vue&type=script&lang=js&"
export * from "./star-rating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71f68a59')) {
      api.createRecord('71f68a59', component.options)
    } else {
      api.reload('71f68a59', component.options)
    }
    module.hot.accept("./star-rating.vue?vue&type=template&id=71f68a59&", function () {
      api.rerender('71f68a59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2NnLtPyl7P2lR/JS/comp/star-rating.vue"
export default component.exports